import { adaptWareHousesToTable } from './adaptWareHousesToTable';

export { adaptWareHousesToTable };
